import React from "react";
import Img, { FluidObject } from "gatsby-image";

export enum ImageRenderType {
	Img = "Img",
	BgImage = "BgImage",
}

interface SharpImageProps {
	childImageSharp: {
		fluid: FluidObject;
	};
}

interface ResponsiveSharpImgProps {
	sharpImage?: SharpImageProps;
	fallbackUrl: string;
	specificUrl?: string;
	className: string;
	altText?: string;
	type: ImageRenderType;
}

const ResponsiveSharpImg: React.FC<ResponsiveSharpImgProps> = ({
	sharpImage,
	fallbackUrl,
	specificUrl,
	className,
	altText,
	type,
}) => {
	if (sharpImage) {
		return (
			<Img
				fluid={sharpImage.childImageSharp?.fluid}
				className={className}
				alt={altText}
			/>
		);
	}

	if (type === ImageRenderType.Img) {
		return (
			<img
				src={specificUrl || fallbackUrl}
				alt={altText || "background image"}
				className={className}
			/>
		);
	}

	return (
		<div
			className={className}
			style={{ backgroundImage: `url(${specificUrl || fallbackUrl})` }}
		/>
	);
};

export default ResponsiveSharpImg;
